import { compact } from 'lodash';

import About from 'app/about';
import Account from 'app/account';
import Auth from 'app/auth';
import Billing from 'app/billing';
import CompanyAccount from 'app/company-account';
import CompanyDashboard from 'app/company-dashboard';
import ContactUs from 'app/contact-us';
import Dashboard from 'app/dashboard';
import Developer from 'app/developer';
import DeveloperV3 from 'app/developer-v3';
import Editor from 'app/editor';
import Entity from 'app/entity';
import Error from 'app/error';
import Explore from 'app/explore';
import GetHelp from 'app/get-help';
import Homepage from 'app/homepage';
import IWasHere from 'app/i-was-here';
import InstantZap from 'app/instant-zap';
import Login from 'app/login';
import MemberHome from 'app/member-home';
import Min from 'app/min';
import Onboarding from 'app/onboarding';
import OpenSource from 'app/opensource';
import Partner from 'app/partner';
import Payment from 'app/payment';
import Push from 'app/push';
import Refresh from 'app/refresh';
import Reporting from 'app/reporting';
import Rover from 'app/rover';
import Service from 'app/service';
import Settings from 'app/settings';
import SharedZap from 'app/shared-zap';
import TaskHistory from 'app/history';
import Team from 'app/team';
import TeamAccount from 'app/team-account';
import TeamExperts from 'app/team-experts';
import Test from 'app/test';
import Track from 'app/track';
import TwoFactor from 'app/two-factor';
import Unsubscribe from 'app/unsubscribe';
import UseCase from 'app/use-case';
import Viewport from 'app/viewport';
import ZapMover from 'app/zap-mover';
import Zapbook from 'app/zapbook';
import { safeExtend } from 'app/common/CommonUtils';

const appPlugins = [
  Track,
  Editor,
  Auth,
  Service,
  Account,
  TaskHistory,
  Homepage,
  ContactUs,
  Dashboard,
  Error,
  Explore,
  GetHelp,
  SharedZap,
  Min,
  Login,
  Settings,
  Reporting,
  TwoFactor,
  Entity,
  ZapMover,
  Team,
  CompanyAccount,
  TeamAccount,
  TeamExperts,
  CompanyDashboard,
  Developer,
  DeveloperV3,
  Zapbook,
  Billing,
  Payment,
  About,
  OpenSource,
  Partner,
  Refresh,
  Rover,
  Viewport,
  Test,
  Onboarding,
  MemberHome,
  Unsubscribe,
  IWasHere,
  InstantZap,
  Push,
  UseCase,
];

export default function() {
  return {
    all: appPlugins,

    get routes() {
      // Grab all the route objects.
      const routeArgs = compact(appPlugins.map(plugin => plugin.routes));

      // Make sure they're all unique.
      const safeExtendRouteArgs = [{}].concat(routeArgs);

      return safeExtend(...safeExtendRouteArgs);
    },

    get reducers() {
      return appPlugins.map(plugin => plugin.reducers);
    },

    get actionsTypes() {
      return appPlugins.map(plugin => plugin.actionTypes);
    },
  };
}
